import { v4 as uuidv4 } from "uuid";

export function generateCustomId() {
  const randomUuid = uuidv4().replace(/-/g, "").toUpperCase();
  const customId = randomUuid.slice(0, 10);
  return customId;
}
